import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sidebar"
export default class extends Controller {
  static targets = ["menu"];

  toggleSidebar() {
    this.menuTarget.classList.toggle("-translate-x-full");
  }
}
